import React, { FC, useMemo } from 'react';
// components
import Gallery from 'components/photo-viewer';
import { IImagesList } from 'components/photo-viewer/entities';
import { isVideo } from 'components/uploaded-images/helpers';
// api
import { TActivityFeedMediaMapped } from 'redux-store/api/activity-feed';

interface IProps {
  mediaData: TActivityFeedMediaMapped;
  openGallery: boolean;
  activeItem: number;
  handleCloseGallery: () => void;
  getMoreMediaItems: () => void;
  hasMoreMediaItems: boolean;
  isMediaItemsFetching: boolean;
}

const MediaGallery: FC<IProps> = ({
  mediaData,
  activeItem,
  openGallery,
  handleCloseGallery,
  getMoreMediaItems,
  hasMoreMediaItems,
  isMediaItemsFetching,
}) => {
  const imagesList: IImagesList[] = !mediaData?.items?.length
    ? []
    : mediaData.items
        .map(([_, dateItems]) => dateItems)
        .flat()
        .map(({ id, url, mimeType, description, location, timestamp, options, index, createdAt, profile }) => {
          const videoPreviewUrl = isVideo(mimeType) && options?.previewUrl ? options.previewUrl : '';
          return {
            id: index,
            imageSrc: url,
            thumbnail: videoPreviewUrl || url,
            itemId: id,
            mimeType,
            description,
            location,
            timestamp,
            previewUrl: videoPreviewUrl,
            createdAt,
            profile,
          };
        });

  const fetchingProps = useMemo(
    () => ({
      fetchData: getMoreMediaItems,
      hasMore: hasMoreMediaItems,
      isFetching: isMediaItemsFetching,
    }),
    [getMoreMediaItems, hasMoreMediaItems, isMediaItemsFetching]
  );

  if (!imagesList.length) {
    return null;
  }

  return (
    <Gallery
      imagesList={imagesList}
      activeIndex={activeItem}
      isOpen={openGallery}
      handleClose={handleCloseGallery}
      fetchingProps={fetchingProps}
      isActivityFeedMedia
    />
  );
};

export default MediaGallery;
